import React from 'react';
import PropTypes from 'prop-types';

export default function ColorSwatchIcon(props) {
  return (
    <svg width="40" height="12" viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M40 10C40 11.1046 39.1046 12 38 12H2C0.895431 12 0 11.1046 0 10V2C0 0.895431 0.895431 0 2 0H38C39.1046 0 40 0.895431 40 2V10Z" fill={props.color || '#FFCC00'}/>
    </svg>
  );
}

ColorSwatchIcon.propTypes = {
  color: PropTypes.string
};